// src/hooks/banks/useRestoreAllBanks.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllBanks } from "../../api/apiBanks";
import { useTranslation } from "react-i18next";

function useRestoreAllBanks() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: restoreAllBanksMutation, isPending: isRestoreAll } = useMutation({
        mutationFn: restoreAllBanks,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["banks"] });
            toast.success(isArabic ? "تم استعادة البنوك المحددة بنجاح" : "Selected banks restored successfully");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في استعادة البنوك" : "Failed to restore banks"));
        },
    });

    return { restoreAllBanks: restoreAllBanksMutation, isRestoreAll };
}

export default useRestoreAllBanks;
